import { createAction } from '@reduxjs/toolkit';

export const setApproveCallAttempt = createAction<{ id: string; attempt: boolean }>('approval/setApproveCallAttempt');
export const setApproveCallTxHash = createAction<{ id: string; txHash: string | null }>('approval/setApproveCallTxHash');
export const setPermitCallAttempt = createAction<{ id: string; attempt: boolean }>('approval/setPermitCallAttempt');
export const setPermitCallData = createAction<{ id: string; callData: string | null; account: string; token: string }>('approval/setPermitCallData');
